export default __webpack_public_path__ + "static/detox-to-zero-fa46bdf9ab64a6b3c31bc9e61a74ac27.png";